import React from 'react'
let PropTypes = React.PropTypes

export class Aprobacion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            estadoCl: false,
            aprobacionSEI: this.props.aprobacionSEI,
            bloqueado: false
        }
        this.cambioCheckboxCliente = (evt)=> {
            let estado = evt.target.checked
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=> {
                this.props.aprobacionCliente(estado)
                    .then(()=> {
                        this.setState({bloqueado: false})
                        this.setState({
                            estadoCl: estado
                        })
                    })
                    .catch(error=> {
                        console.log("error")
                    })
            })
        }
    }
    componentWillReceiveProps(nextProps){
        this.setState({estadoCl: this.props.aprobacionCl})
    }
    
    render() {
        return (
            <div className={'panel panel-primary'}>
                <div className={'panel-heading'}>Aprobación mensual auditorías{this.props.aprobacionCl}</div>
                <ul className={'list-group'}>
                    {this.props.permisos.cliente?
                        <li className={'list-group-item'}>
                        <span className={'badge'}>
                            <input
                                checked={this.state.estadoCl}
                                type="checkbox"
                                onChange={this.cambioCheckboxCliente.bind(this)}
                                disabled={this.state.bloqueado}
                            />
                        </span>
                            Aprobación cliente
                        </li>
                        :
                        <li className={'list-group-item'}>
                            <span className={'badge'}><input type="checkbox" disabled/></span>
                            Aprobación SEI
                        </li>
                    }    
                    
                    {this.props.permisos.facturar?
                        <li className={'list-group-item'}>
                            <span className={'badge'}><input type="checkbox" disabled/></span>
                            Aprobación SEI
                        </li>
                        :
                        <li className={'list-group-item'}>
                            <span className={'badge'}>
                                <input 
                                    type="checkbox"
                                    checked={this.state.aprobacionSEI}
                                    value={this.state.aprobacionSEI}
                                    //onChange={this.cambioCheckboxSEI.bind(this)}
                                    disabled
                                />
                            </span>
                            Aprobación SEI
                        </li>
                    }
                </ul>
            </div>
        )
    }
}
Aprobacion.propTypes = {
    aprobacionCl: PropTypes.bool
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/Aprobacion.jsx